<template>
  <el-row class="container homeFrame">
    <el-col :span="24" class="header">
      <div class="topMain centerMain">
        <div class="logo fl" @click='logo'>
          <img class="logoImg" src="../assets/logo.png" alt="">
        </div>
        <ul class="homeNavs fl">
          <!--<li v-for="item in $store.state.systemInfo.navs">-->
          <!--<router-link :class="item.className" :to='item.to' >{{item.title}}</router-link>-->
          <!--</li>-->
          <li>
            <router-link :class="$store.state.systemInfo.navs[0].className" :to='$store.state.systemInfo.navs[0].to'>
              {{$store.state.systemInfo.navs[0].title}}
            </router-link>
          </li>
          <li>
            <router-link :class="$store.state.systemInfo.navs[1].className" :to='$store.state.systemInfo.navs[1].to'>
              {{$store.state.systemInfo.navs[1].title}}
            </router-link>
          </li>
          <li style="position: relative" @click="shows('ulshow')" @mouseleave="hiddens">
            <router-link :class="$store.state.systemInfo.navs[2].className" :to='$store.state.systemInfo.navs[2].to'>
              {{$store.state.systemInfo.navs[2].title}}
            </router-link>
            <ul ref="ulshow" class="secondUl"  @mouseleave="hiddens">
              <li @click="newType('3')">援外行动</li>
              <li @click="newType('1')">全国行动</li>
              <li @click="newType('2')">单省行动</li>
              <li @click="newType('4')">个人行动</li>
              <li @click="newType('5')">专家工作站</li>
            </ul>
          </li>
          <!--志愿招募-->
          <li style="position: relative" @click="shows('zhishow')" @mouseleave="hiddens">
            <router-link :class="$store.state.systemInfo.navs[3].className" :to='$store.state.systemInfo.navs[3].to'>
              <span> {{$store.state.systemInfo.navs[3].title}}</span>
            </router-link>
            <ul ref="zhishow" class="secondUl" @mouseleave="hiddens">
              <li @click="valunteer('1')">志愿活动招募</li>
              <li @click="valunteer('2')">志愿医生注册</li>
              <li @click="valunteer('3')">志愿者招募</li>
            </ul>

          </li>
          <li @click="shows('shenshow')" style="position: relative" @mouseleave="hiddens">
            <router-link :class="$store.state.systemInfo.navs[4].className" :to='$store.state.systemInfo.navs[4].to'>
              <span>{{$store.state.systemInfo.navs[4].title}}</span>
            </router-link>
            <ul ref="shenshow" class="secondUl" @mouseleave="hiddens">
              <li @click="apply('1')">申请专家工作站</li>
              <li @click="apply('2')">申请村医培训</li>
              <li @click="apply('3')">申请援助活动</li>
            </ul>

          </li>

          <li>
            <router-link :class="$store.state.systemInfo.navs[5].className" :to='$store.state.systemInfo.navs[5].to'>
              {{$store.state.systemInfo.navs[5].title}}
            </router-link>
          </li>
          <!--<li>-->
          <!--<router-link :class="$store.state.systemInfo.navs[5].className" :to='$store.state.systemInfo.navs[5].to' >{{$store.state.systemInfo.navs[5].title}}</router-link>-->
          <!--</li>-->
          <!--培训-->
          <li @click="shows('usshow')" style="position: relative" @mouseleave="hiddens">
            <router-link :class="$store.state.systemInfo.navs[6].className" :to='$store.state.systemInfo.navs[6].to'>
              <span>{{$store.state.systemInfo.navs[6].title}}</span>
            </router-link>
            <ul ref="usshow" class="secondUl" @mouseleave="hiddens">
              <li @click="about('1')">北京凌锋公益基金</li>
              <li @click="about('2')">团队介绍</li>
              <li @click="about('3')">联系我们</li>
            </ul>

          </li>

          <li>
            <router-link :class="$store.state.systemInfo.navs[7].className" :to='$store.state.systemInfo.navs[7].to'>
              {{$store.state.systemInfo.navs[7].title}}
            </router-link>
          </li>

          <!--<li>-->
          <!--<router-link :class="$store.state.systemInfo.navs[8].className" :to='$store.state.systemInfo.navs[8].to' >{{$store.state.systemInfo.navs[8].title}}</router-link>-->
          <!--</li>-->

        </ul>
        <div class="userinfo fr" v-if='!$store.state.isLogin'>
          <router-link to='/login'>登录</router-link>
          <span style="font-size: 13px">|</span>
          <router-link to='/registPage'>注册</router-link>
        </div>
        <div class="userinfo fr" v-if='$store.state.isLogin'>
          <a href='javascript:;' @click='toggleLoginRoute' class="fl">
                        <span class="el-dropdown-link userinfo-inner">
                            <img class='czposition' :src="$store.state.loginRuler.icon"/>
                            {{$store.state.loginRuler.name}}
                        </span>
          </a>
          <a href="javascript:;" class="fl logout" @click='logout'>退出</a>
        </div>
      </div>
    </el-col>
    <transition name="fade" mode="out-in">
      <router-view id="vews"></router-view>
    </transition>
  </el-row>
</template>

<script>
  export default {
    inject: ['reload'],
    data: function () {
      return {
        collapsed: false,
        sysUserName: '',
        sysUserAvatar: '',
        form: {
          name: '',
          region: '',
          date1: '',
          date2: '',
          delivery: false,
          type: [],
          resource: '',
          desc: ''
        }
      }
    },
    created: function () {
      var userId = localStorage.getItem("userId");
      if (userId != null && userId != "") {
        this.$store.dispatch('setLoginState', {flag: true})
      } else {
        this.$store.dispatch('setLoginState', {flag: false})
      }
      var name = localStorage.getItem("name");
      var icon = localStorage.getItem("icon");
      var userObj = {};
      userObj.name = name ? name : '未命名';
      userObj.icon = icon ? icon : this.$store.state.loginRuler.icon;
      this.$store.dispatch('setUser', userObj);
    },
    methods: {
      shows(data) {
        this.hiddens()
        if (data == "ulshow") {
          this.$refs.ulshow.style.display = "block"
        } else if (data == 'zhishow') {
          this.$refs.zhishow.style.display = "block"
        } else if (data == 'shenshow') {
          this.$refs.shenshow.style.display = "block"
        } else {
          this.$refs.usshow.style.display = "block"
        }
      },
      hiddens(data) {

          this.$refs.usshow.style.display = "none"
          this.$refs.shenshow.style.display = "none"
          this.$refs.zhishow.style.display = "none"
          this.$refs.ulshow.style.display = "none"

      },
      about(index) {
        this.$store.commit("reverseAbout",index)

      },
      newType(index) {
        this.$store.commit("reverse", index)
      },
      valunteer(index) {
        if (index == '2') {
          if (this.$store.state.isLogin){
            this.$router.push('/regist')
          } else{
            this.$router.push('/registPage')
          }
          this.reload()
        } else if (index == '3') {
          this.$router.push('/moveVolunteer')
          this.reload()
        } else if (index == '1') {
          this.$router.push('/activelist')
          this.reload()
        }
      },

      apply(index) {
        this.$store.commit("reversShow",index)
      },


      toggleLoginRoute: function () {
        console.log(this.$store.state.isRegist);
        if (this.$store.state.isRegist) {
          this.$router.push('/detail')
        } else {
          this.$router.push('/regist')
        }
      },
      onSubmit: function () {
        console.log('submit!');
      },
      handleopen: function () {
        //console.log('handleopen');
      },
      handleclose: function () {
        //console.log('handleclose');
      },
      handleselect: function (a, b) {
      },
      logo: function () {
        this.$router.push('/home')
      },
      //退出登录
      logout: function () {
        var _this = this;
        this.$confirm('确认退出吗?', '提示', {
          //type: 'warning'
        }).then(function () {
          localStorage.removeItem('user');
          localStorage.removeItem('userId');
          _this.$store.dispatch('setLoginState', {flag: false})
          _this.$router.push('/Login')
        }).catch(function () {

        });
      },
      //折叠导航栏
      collapse: function () {
        this.collapsed = !this.collapsed;
      },
      showMenu(i, status) {
        this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-' + i)[0].style.display = status ? 'block' : 'none';
      }
    },
    mounted: function () {
    }
  }

</script>

<style scoped>
  #vews {
    padding-top: 86px;
  }

  * {
    font-size: 16px;
  }

  .container {
    top: 0px;
    bottom: 0px;
    width: 100%;
  }

  .container .header {
    color: #fff;
    top: 0;
    z-index: 99;
    position: absolute;
    background-color: #fff;
    height: 86px;
  }

  .topMain {
    height: 86px;
    line-height: 86px;
    position: relative;
  }

  .container .header .userinfo {
    float: right;
    font-size: 16px;
    color: #555;
    position: absolute;
    right: 0;
  }

  .container .header .userinfo a.logout {
    padding-left: 10px;
    color: #666;
  }

  .container .header .userinfo .userinfo-inner {
    cursor: pointer;
    color: #231916;
    position: relative;
    height: 100%;
    padding-left: 35px;
  }

  .container .header .userinfo .userinfo-inner img {
    width: 30px;
    height: 30px;
    border-radius: 20px;
    float: left;
    position: absolute;
    left: 0;
  }

  .homeNavs {
    height: 100%;
    position: absolute;
    left: 50%;
    margin-left: -350px;
  }

  .homeNavs li {
    font-size: 16px;
    margin: 0 16px;
    box-sizing: border-box;
    height: 100%;
    display: inline-block;
  }

  .homeNavs li a {
    font-size: 16px;
    padding: 15px 0;
    color: #555;
  }

  .logo {
    margin-right: 136px;
    height: 100%;
    z-index: 9999;
  }

  .logo:hover {
    cursor: pointer;
  }

  img.logoImg {
    margin-top: 20px;
    width: 172px;
    height: 40px;
  }

  .homeNavs .router-link-active {
    color: #D61819;
    border-bottom: 2px solid red;
  }

  .main aside {
    flex: 0 0 230px;
    width: 230px;

  }

  .business_title1 {
    margin-top: 470px;
  }

  .secondUl {
    width: 160px;
    display: none;
    padding: 10px;
    position: absolute;
    top: 58px;
    left: -37px;
    z-index: 10;
    /*background: #ffff;*/
    border-radius: 10px;

  }

  .secondUl li {
    width: 100%;
    display: block;
    margin: 8px 0px;
    color: #555555;
    text-align: center;
    height: 20px;
    line-height: 20px;
  }
  ul li:hover{
    cursor: pointer;
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/homeFrame.vue